import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'vc-prevent-close-popin',
  templateUrl: './prevent-close-popin.component.html',
  styleUrls: ['./prevent-close-popin.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreventClosePopinComponent {
  constructor(public dialogRef: MatDialogRef<PreventClosePopinComponent>) {}

  close(quit: boolean) {
    this.dialogRef.close(quit);
  }
}
